import { useSearchQuery } from 'Core/Hooks/useSearchQuery'
import { addSpaces } from 'Utils/PureHelperFuctions'
import { IconInfoRow, SearchInput } from 'V2Components'
import { useCloudDetailsProvider } from 'features/clouds'
import { createRsrcKey, getResourceName, isResourceManaged } from 'features/resources'
import { getHTMLDataTestID } from 'infra/utils'
import { IamRolesCard, Typography } from 'procyon-ui'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getAWSResourceIcon } from 'Components/CustomIcons/AWSResources'
import { fetchAllCloudResources } from 'features/clouds/utils/CloudResourcesSlice'

const AWSResources = () => {
  const [activeResourceType, setIsActive] = useState('')
  const [searchKey, setSearchKey] = useState('')

  const { cloud: account } = useCloudDetailsProvider()
  const dispatch = useDispatch()

  const {
    data: resources,
    loading,
    loaded
  } = useSelector((state) => state.cloudResources[`AWS_all`] || {})

  useEffect(() => {
    if (!loaded) {
      dispatch(fetchAllCloudResources({ cloudType: 'AWS' }))
    }
  }, [dispatch, loaded])

  const { applySearchQuery } = useSearchQuery({
    queryKey: searchKey,
    defaultQueryFunction: (a, queryKey) => {
      const rName = getResourceName(a)
      return `${rName}`.toLowerCase().includes(queryKey)
    }
  })

  const getResourcesRefs = () => {
    const counts = {}
    if (resources) {
      resources.forEach((d) => {
        const type = d.ObjectMeta.Namespace
        if (!counts[type]) {
          counts[type] = []
        }
        counts[type].push(d)
      })
    }
    if (Object.keys(counts).length > 0 && !activeResourceType) {
      setIsActive(Object.keys(counts)[0])
    }
    return counts
  }

  const rsrcRefs = getResourcesRefs()

  const getResourceNodes = () => {
    const rsrcs = rsrcRefs[activeResourceType] || []
    return applySearchQuery(rsrcs)
  }

  if (loading) {
    return <div>Loading...</div>
  }

  return (
    <div className='flex gap-4'>
      <div className='w-1/2 border-[#D8DDE4] border-r pr-5'>
        <Typography
          style={{ color: 'var(--color-font-base)' }}
          variant='h4-regular'
          className='mb-4'
        >
          Select Resource Type
        </Typography>

        <div className='mt-10'>
          {Object.entries(rsrcRefs).map(([targetType, resources]) => {
            const count = resources.length
            if (count === 0) return null
            const Icon = getAWSResourceIcon(targetType, true)

            return (
              <IconInfoRow
                className='my-2'
                key={targetType}
                data-testid={getHTMLDataTestID('clouds-aws', 'div', 'icon-info-row', targetType)}
                title={targetType}
                subtitle={`${count} Total`}
                Icon={<Icon />}
                isActive={activeResourceType === targetType}
                onClick={() => setIsActive(targetType)}
              />
            )
          })}
        </div>
      </div>
      <div className='w-1/2'>
        <div
          data-testid={getHTMLDataTestID('resource', 'div', activeResourceType)}
          className='flex justify-between items-center'
        >
          <Typography style={{ color: 'var(--color-font-base)' }} variant='h4-regular'>
            {activeResourceType}
          </Typography>
          <SearchInput sx={{ width: '280px' }} searchKey={searchKey} onChange={setSearchKey} />
        </div>
        <div className='flex justify-between items-center mt-4'></div>
        <div className='mt-4'>
          {getResourceNodes().map((rsrc) => {
            const Icon = getAWSResourceIcon(rsrc)
            return (
              <IamRolesCard
                data-testid={getHTMLDataTestID(
                  'clouds-aws',
                  'div',
                  'roles-card',
                  rsrc.ObjectMeta.Name
                )}
                isCheckedSwitch={isResourceManaged(rsrc)}
                key={createRsrcKey(rsrc)}
                className='mb-4'
                style={{ width: '100%' }}
                expandable={false}
                buttonType='none'
                description={addSpaces(rsrc.ObjectMeta.Kind)}
                icon={<Icon />}
                title={getResourceName(rsrc)}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}

export { AWSResources }
